<template>
  <div class="">
    <div class="d-flex flex-row align-center justify-space-between mb-4">
      <div class="top-header mb-0">{{ $t("ClientsAccounts") }}</div>
    </div>

    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>

    <div class="d-flex flex-row align-center justify-end mb-5">
      <v-text-field
        v-model="qSearch"
        solo
        dense
        flat
        style="max-width: 250px; border-radius: 8px"
        hide-details
        :label="$t('SearchAccounts') + '...'"
        @keydown.enter="getClients()"
      >
        <img
          slot="prepend-inner"
          width="20px"
          height="20px"
          src="/icons/search.svg"
        />
      </v-text-field>

      <v-btn
        depressed
        tile
        class="text-capitalize white--text ml-5"
        color="#0F52BC"
        @click="getClients()"
      >
        <img width="32px" height="32px" src="/icons/reload.svg" />
        {{ $t("Reload") }}
      </v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="clients"
      :options.sync="options"
      :server-items-length="totalClients"
      :loading="loadingTable"
      :loading-text="`${$t('Loading')}... ${$t('PleaseWait')}`"
      :footer-props="footerProps"
    >
      <template v-slot:[`item.answer`]="{ item }">
        <div class="d-flex flex-row justify-end" style="width: 100%">
          <v-btn
            icon
            small
            :disabled="!hasPermissions(answerPerms)"
            :title="`${$t('SendSms')}`"
            @click="openDialog(item)"
          >
            <img width="20px" height="20px" src="/icons/message.svg" />
          </v-btn>
          <v-btn
            icon
            small
            @click="openDialogEmail(item)"
            :title="`${$t('SendEmail')}`"
            :disabled="!hasPermissions(answerPerms)"
          >
            <img width="20px" height="20px" src="/icons/email.svg" />
          </v-btn>
          <v-menu bottom left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon v-bind="attrs" v-on="on">
                <img width="20px" height="20px" src="/icons/more.svg" />
              </v-btn>
            </template>

            <v-list nav>
              <v-list-item link>
                <v-list-item-title @click="goToClient(item)"
                  >Client details</v-list-item-title
                >
              </v-list-item>
              <v-list-item link>
                <v-list-item-title @click="openDialogChangePassword(item)"
                  >Change password</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
      <template slot="header">
        <tr class="hidden-sm-and-down">
          <th>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" small @click="getClients()">
                  <img width="20px" height="20px" src="/icons/filter.svg" />
                </v-btn>
              </template>
              <span>filter clients</span>
            </v-tooltip>
          </th>
          <th>
            <v-text-field
              class="mt-5 client-filter-input"
              dense
              outlined
              placeholder=" "
              label="Name"
              v-model="filterParams.name"
              @keydown.enter="getClients()"
            ></v-text-field>
          </th>
          <th>
            <v-text-field
              class="mt-5 client-filter-input"
              dense
              outlined
              placeholder=" "
              label="Email"
              v-model="filterParams.email"
              @keydown.enter="getClients()"
            ></v-text-field>
          </th>
          <th>
            <v-text-field
              class="mt-5 client-filter-input"
              dense
              outlined
              placeholder=" "
              label="Phone"
              v-model="filterParams.phone"
              @keydown.enter="getClients()"
            ></v-text-field>
          </th>
        </tr>
      </template>
    </v-data-table>
    <v-dialog
      content-class="dialog-shaped"
      v-model="answerDialog"
      max-width="500px"
    >
      <v-card class="pa-3">
        <v-card-title class="mt-10">
          <span class="dialog-title orange--text text--darken-2">
            Send sms to: {{ selectedUser.email }}
          </span>
          <v-btn class="btn-close" icon @click="closeAnswerDialog()">
            <img width="32px" height="32px" src="/icons/close-black.svg" />
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-textarea
                dense
                outlined
                v-model="answerText"
                :no-resize="true"
                rows="5"
                :rules="[v => !!v || 'required']"
                label="Sms body"
                placeholder=" "
              ></v-textarea>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="mb-10">
          <v-btn
            color="grey darken-4"
            class="white--text ml-5 px-3"
            depressed
            tile
            width="150"
            @click="closeAnswerDialog()"
          >
            <img
              class="mr-2"
              width="24px"
              height="24px"
              src="/icons/close-white.svg"
            />
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-5 white--text px-3"
            color="orange darken-2"
            depressed
            tile
            width="150"
            :loading="sending"
            @click="sendAnswer()"
          >
            <img
              class="mr-2"
              width="24px"
              height="24px"
              src="/icons/send.svg"
            />
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      content-class="dialog-shaped"
      v-model="answerDialogEmail"
      max-width="500px"
    >
      <v-card class="pa-3">
        <v-card-title class="mt-10">
          <span class="dialog-title orange--text text--darken-2">
            Send email to: {{ selectedUser.email }}
          </span>
          <v-btn class="btn-close" icon @click="closeAnswerDialogEmail()">
            <img width="32px" height="32px" src="/icons/close-black.svg" />
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-textarea
                dense
                outlined
                v-model="answerEmail"
                :no-resize="true"
                rows="5"
                :rules="[v => !!v || 'required']"
                label="Email body"
                placeholder=" "
              ></v-textarea>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="mb-10">
          <v-btn
            color="grey darken-4"
            depressed
            tile
            class="white--text ml-5 px-3"
            width="150"
            @click="closeAnswerDialogEmail()"
          >
            <img
              class="mr-2"
              width="24px"
              height="24px"
              src="/icons/close-white.svg"
            />
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-5 white--text px-3"
            depressed
            tile
            width="150"
            :loading="sending"
            color="orange darken-2"
            @click="sendAnswerEmail()"
          >
            <img
              class="mr-2"
              width="24px"
              height="24px"
              src="/icons/send.svg"
            />
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      content-class="dialog-shaped"
      v-model="changePasswordDialog"
      max-width="500px"
    >
      <v-card class="pa-3">
        <v-card-title class="mt-10">
          <div class="mb-3 dialog-title orange--text text--darken-2">
            Change password
          </div>
          <v-btn class="btn-close" icon @click="closeChangePasswordDialog()">
            <img width="32px" height="32px" src="/icons/close-black.svg" />
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-text-field
                dense
                outlined
                type="password"
                v-model="newPassword"
                :rules="[v => !!v || 'required']"
                label="New password"
              ></v-text-field>
              <v-text-field
                dense
                outlined
                type="password"
                v-model="verifyPassword"
                :rules="[v => !!v || 'required', passwordMatch]"
                label="Confirm password"
              ></v-text-field>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="mb-10">
          <v-btn
            color="grey darken-4"
            depressed
            tile
            class="white--text ml-5 px-3"
            width="150"
            @click="closeChangePasswordDialog()"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="mr-5 white--text px-3"
            depressed
            tile
            width="150"
            :loading="sending"
            color="orange darken-2"
            @click="changePassword()"
          >
            <img
              class="mr-2"
              width="24px"
              height="24px"
              src="/icons/reload.svg"
            />
            Change
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RestResourceClient from "@/api/apiClientService";
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import { Permission } from "@/utils/permissions";
import { permissionMixin } from "@/utils/mixins";
import { vdataTable } from "@/plugins/vuetify-custom-props";
import RestResourceSms from "../../api/apiSmsService";
import RestResourceUser from "../../api/apiUserService";
export default {
  name: "ClientList",
  mixins: [permissionMixin],
  data() {
    return {
      loadingTable: false,
      clients: [],
      options: {},
      footerProps: {
        ...vdataTable.footerProps,
        prevIcon: "mdi-chevron-left orange--text text--darken-2",
        nextIcon: "mdi-chevron-right orange--text text--darken-2"
      },
      totalClients: 0,
      answerDialog: false,
      answerDialogEmail: false,
      changePasswordDialog: false,
      answerText: null,
      answerEmail: null,
      sending: false,
      qSearch: "",
      StripeTerminal: null,
      errorAlert: false,
      errorMsg: "",
      terminal: null,
      filterParams: {
        name: null,
        email: null,
        phone: null,
        role: "Client",
        created: false
      },
      selectedUser: {
        _id: "",
        phone: "",
        email: ""
      },
      userDefault: {
        _id: "",
        phone: "",
        email: ""
      },
      headers: [
        {
          align: "start",
          sortable: false,
          width: 100,
          value: "edit"
        },
        {
          text: this.$t("Name"),
          width: 225,
          align: "start",
          sortable: false,
          value: "fullName"
        },
        { text: "Email", value: "email", sortable: false },
        { text: "Phone", value: "phone", sortable: false },
        {
          text: "Register date",
          value: "createdAt",
          sortable: false,
          float: "right"
        },
        {
          text: "Options",
          sortable: false,
          align: "end",
          value: "answer"
        }
      ],
      newPassword: "",
      verifyPassword: ""
    };
  },
  watch: {
    options: {
      handler() {
        this.getClients();
      },
      deep: true
    }
  },
  computed: {
    detailsPencilPerms() {
      return [Permission.LIST_CLIENT];
    },
    answerPerms() {
      return [Permission.CONTACT_USER];
    },
    passwordMatch() {
      return () =>
        this.newPassword === this.verifyPassword ||
        this.$t("errors.passMustMatch");
    }
  },
  methods: {
    async getClients() {
      if (this.qSearch.length >= 1 && this.qSearch.length <= 2) {
        this.errorAlert = true;
        this.errorMsg = "The search must have 3 or more characters.";
        return;
      }
      this.loadingTable = true;
      RestResourceClient.prototype
        .getClients(this.getParams())
        .then(async response => {
          if (response.status === ResponseStatus.OK) {
            this.totalClients = response.data.total;
            this.clients = response.data.data;
            console.log(this.clients);
            this.clients.map(client => {
              client.fullName = client.name + " " + client.lastName;
            });
            this.clients.forEach((client, index) => {
              this.clients[index].createdAt = this.clients[index].createdAt
                .split("T")
                .join(" ")
                .split("-")
                .join("/")
                .split(".")[0];
            });
          }
        })
        .catch(error => {
          this.errorAlert = true;
          this.errorMsg = error.response.data.message;
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },
    goToClient(client) {
      this.$router.push({
        name: "clientId",
        params: { id: client._id }
      });
    },
    openDialog(item) {
      this.selectedUser = Object.assign({}, item);
      this.answerDialog = true;
    },
    openDialogEmail(item) {
      this.selectedUser = Object.assign({}, item);
      this.answerDialogEmail = true;
    },
    openDialogChangePassword(item) {
      this.selectedUser = Object.assign({}, item);
      this.changePasswordDialog = true;
    },
    closeAnswerDialog() {
      setTimeout(() => {
        this.selectedUser = Object.assign({}, this.userDefault);
        this.answerText = "";
        this.$refs.form.reset();
      }, 500);
      this.answerDialog = false;
    },
    closeAnswerDialogEmail() {
      setTimeout(() => {
        this.selectedUser = Object.assign({}, this.userDefault);
        this.answerEmail = "";
        this.$refs.form.reset();
      }, 500);
      this.answerDialogEmail = false;
    },
    closeChangePasswordDialog() {
      setTimeout(() => {
        this.selectedUser = Object.assign({}, this.userDefault);
        this.newPassword = "";
        this.verifyPassword = "";
        this.$refs.form.reset();
      }, 500);
      this.changePasswordDialog = false;
    },
    async sendAnswer() {
      if (!this.$refs.form.validate()) return;
      try {
        this.sending = true;
        await RestResourceSms.prototype.sendSmsToUser({
          email: this.selectedUser.email,
          body: this.answerText
        });
        this.closeAnswerDialog();
      } catch (error) {
        this.errorAlert = true;
        this.errorMsg = error.response.data.message;
        this.closeAnswerDialog();
      } finally {
        this.sending = false;
      }
    },
    async sendAnswerEmail() {
      if (!this.$refs.form.validate()) return;
      try {
        this.sending = true;
        await RestResourceSms.prototype.sendEmailToUser({
          userId: this.selectedUser._id,
          body: this.answerEmail
        });
        this.closeAnswerDialogEmail();
      } catch (error) {
        this.errorAlert = true;
        this.errorMsg = error.response.data.message;
        this.closeAnswerDialogEmail();
      } finally {
        this.sending = false;
      }
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      let params = {
        q: this.qSearch || null,
        skip: (page - 1) * itemsPerPage,
        limit: itemsPerPage
      };
      params = { ...params, ...this.filterParams };
      return params;
    },
    async changePassword() {
      try {
        this.sending = true;
        await RestResourceUser.prototype.changeUserPassword({
          newPassword: this.newPassword,
          verifyPassword: this.verifyPassword,
          userId: this.selectedUser._id,
          userRole: this.selectedUser.role
        });
        this.closeChangePasswordDialog();
      } catch (e) {
        this.errorAlert = true;
        this.errorMsg = e.response.data.message;
        this.closeChangePasswordDialog();
      } finally {
        this.sending = false;
      }
    }
  }
};
</script>

<style>
.client-filter-input >>> .v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
  font-size: 1rem !important;
  font-weight: 200;
}
.client-filter-input >>> .v-select__slot .v-input__append-inner {
  margin-top: 5px !important;
}
.client-filter-input >>> .v-select__selections {
  font-size: 12px;
}
</style>
